// TODO: Add global mutations as defined. e.g. GET_ORGANIZATION, LOG_OUT, etc.
export const GET_ORGANIZATION = () => {};